var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"marketHistoryTabs"}},[_c('ejs-tab',{ref:"marketHistoryTabs",attrs:{"id":"element","selecting":_vm.selecting}},[_c('e-tabitems',[_c('e-tabitem',{attrs:{"header":_vm.headerText0,"content":_vm.powerHistory}}),_c('e-tabitem',{attrs:{"header":_vm.headerText1,"content":_vm.gasHistory}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }